import { IDimensions, useWidgetContext } from '@dxp-module/common'
import generateApolloClient from '../graphql/generateApolloClient'

const useApolloClient = () => {
  const {
    configuration: { dimensions, seSessionId },
  } = useWidgetContext()
  const client = generateApolloClient(
    dimensions as IDimensions,
    seSessionId
      ? {
          ['X-SE-Session' as string]: seSessionId,
        }
      : {}
  )

  return { client }
}

export default useApolloClient
